export default {
    name: 'DownData',
    data() {
        return {
            code:'', 
            loading: false,
            downresult:'',
        };
    },
    methods: {
        // 用于初始化一些数据
        init() {
        },
        // 下载所有美股代码
        async downStockCode() { 
        this.loading = true;
        this.downresult="正在下载所有美股代码"; 
        const res = await this.$http.post('DownEast/GetLoadAllOfUsCode', {id:1});
        if(res.Status){
            this.downresult="下载所有美股代码成功"; 
        }
        
        this.loading = false;
 

        },
        // 下载所有企业信息
        async downCompanyInfo(el){
            this.loading = true; 
            this.downresult="正在下载所有美股企业信息"; 
            const res = await this.$http.post('DownEast/GetLoadAllOfUsCompanyInfo', {id:1});
            if(res.Status){
                this.downresult="下载所有美股企业信息完成"; 
            }
            
            this.loading = false;
        },
        // 下载所有企业财报信息
       async downFinanceInfo(){
           
        this.loading = true;
        this.downresult="正在下载所有企业财报信息";
        const res = await this.$http.post('DownEast/GetLoadAllOfUsFinanceInfo', {id:1});//id=0 全部美股涨幅
        if(res.Status){

            this.downresult="下载所有企业财报信息完成"; 

        }
        
        this.loading = false;
    
       },  
        
    },
    // 计算属性
    computed: {
        identity() {
            let identity = '管理员';
            return identity;
        }
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() {
         
    },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
        this.$nextTick(() => { 
            this.init();
        });
    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {},
    // 组件列表
    components: {},
};